<template>
  <div>
    <div v-for="(option, index) in step.options" class="klickbox-step-options">
      <label>
        <input
          disabled
          :type="[step.multiple_answers ? 'checkbox' : 'radio']"
          :name="step.id"
          :value="option.label">
        <input
          type="text"
          :value="option.label"
          class="klickbox-step-input-edit"
          :class="{ 'klickbox-step-input-other': option.other }"
          :placeholder="$t('edit.canvas.multiple_choice_placeholder')"
          @change="optionUpdateText({ event: $event, id: option.id })">
        <span class="klickbox-step-bar"></span>
      </label>
      <div
        v-if="!option.other && step.kind !== 'yes-no'"
        class="klickbox-step-remove-option"
        @click="optionRemove({ id: option.id, index })">
        <i class="fa fa-times"></i>
      </div>
    </div>
    <div v-if="step.kind === 'multiple-choice'" class="klickbox-step-options">
      <label
        class="klickbox-step-add-option"
        @click="optionAdd({ other: false })">
        <input :type="[step.multiple_answers ? 'checkbox' : 'radio']" disabled>
        {{ $t('edit.canvas.add_option') }}
        </label>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: [
    'step',
  ],
  methods: mapActions([
    'optionUpdateText',
    'optionAdd',
    'optionRemove',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** MultipleChoice.vue?1a5b606e
 **/